import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import {FC} from 'react';
import {c} from 'ttag';

const NavigationTabsBilling: FC<NavigationTabsPropsHelper> = ({
    className,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        <BaseNavigationTabsButton
            href={window.Urls.billing_details()}
            label={c('component').t`Billing Details`}
            name="billingDetails"
        />
        <BaseNavigationTabsButton
            href={window.Urls.billing_index()}
            label={c('component').t`Change Subscription`}
            name="changeSubscription"
        />
        <BaseNavigationTabsButton
            href={window.Urls.billing_mailpoints_react_view()}
            label={c('component').t`Buy MailPoints`}
            name="buyMailPoints"
        />
    </BaseNavigationTabs>
);

export default NavigationTabsBilling;
